// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import Head from "next/head";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Router from "next/router";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as Environments$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/Environments.mjs";
import * as CanonicalHelper$PorterinFeature from "../../../core/helpers/CanonicalHelper.mjs";

function SEOCmp(Props) {
  var seo = Props.seo;
  var router = Router.useRouter();
  var shouldFilterSchemas = router.locale === "en-IN" && (router.pathname.includes("/trucks") || router.pathname.includes("/bikes") || router.pathname.includes("/two-wheelers"));
  var renderLocalData = function (local_data) {
    return Belt_Array.mapWithIndex(Belt_List.toArray(local_data), (function (index, data) {
                  return React.createElement("script", {
                              key: String(index),
                              id: "data",
                              type: "application/ld+json",
                              dangerouslySetInnerHTML: {
                                __html: JSON.stringify(data)
                              }
                            });
                }));
  };
  var match = Config$PorterinUtils.env === Environments$PorterinUtils.production || Config$PorterinUtils.env === Environments$PorterinUtils.prod;
  var match$1 = seo.is_no_index;
  var tmp;
  var exit = 0;
  if (match && !match$1) {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement("meta", {
          content: "noindex, nofollow",
          name: "robots"
        });
  }
  return React.createElement(Head, {
              children: null
            }, React.createElement("title", undefined, seo.title), React.createElement("meta", {
                  content: seo.meta_description,
                  name: "description"
                }), React.createElement("meta", {
                  content: seo.title,
                  property: "og:title"
                }), React.createElement("meta", {
                  content: seo.meta_description,
                  property: "og:description"
                }), React.createElement("meta", {
                  content: seo.image.path,
                  property: "og:image"
                }), React.createElement("meta", {
                  content: seo.title,
                  property: "og:image:alt"
                }), React.createElement("meta", {
                  content: "image/jpeg",
                  property: "og:image:type"
                }), React.createElement("meta", {
                  content: "1200",
                  property: "og:image:width"
                }), React.createElement("meta", {
                  content: "630",
                  property: "og:image:height"
                }), React.createElement("meta", {
                  content: CanonicalHelper$PorterinFeature.getCanonicalUrl(router),
                  property: "og:url"
                }), React.createElement("link", {
                  href: CanonicalHelper$PorterinFeature.getCanonicalUrl(router),
                  rel: "canonical"
                }), shouldFilterSchemas ? null : renderLocalData(seo.local_data), React.createElement("link", {
                  href: "https://dom-content-vault-prod-cdn-assets.porter.in/favicon_d9cd692972/favicon_d9cd692972.png",
                  rel: "shortcut icon"
                }), React.createElement("meta", {
                  charSet: "UTF-8"
                }), React.createElement("meta", {
                  content: "max-image-preview:large, max-snippet:-1, max-video-preview:-1",
                  name: "robots"
                }), React.createElement("meta", {
                  content: "width=device-width, maximum-scale=1.0, initial-scale=1.0, user-scalable=no, minimum-scale=1.0",
                  name: "viewport"
                }), React.createElement("link", {
                  href: "https://dom-content-vault-prod-cdn-assets.porter.in",
                  rel: "preconnect"
                }), React.createElement("link", {
                  href: "https://dom-content-vault-prod-cdn-assets.porter.in",
                  rel: "dns-prefetch"
                }), React.createElement("link", {
                  href: "https://fonts.googleapis.com",
                  rel: "preconnect"
                }), React.createElement("link", {
                  href: "https://fonts.googleapis.com/css2?family=Titillium+Web:wght@300;400;500;600;700&display=swap",
                  rel: "stylesheet"
                }), React.createElement("link", {
                  href: "/manifest.json",
                  rel: "manifest"
                }), tmp);
}

var make = SEOCmp;

export {
  make ,
}
/* react Not a pure module */
